'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    function init() {

        context.find('[data-binding="pl-menu"]').load('/pattern-lib/nav.html');
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/pattern-library.js
// module id = 516
// module chunks = 0